module.exports = __webpack_public_path__ + "static/media/vijay.cb97594c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/vijay.jpg
// module id = 1697
// module chunks = 157